import React from 'react';
import { Table } from 'semantic-ui-react';
import { reduce } from 'ramda';
import { withNamespaces } from 'react-i18next';


const sum = (data, key) =>
      reduce((acc, val) =>
             val[key] ? acc += val[key]: acc, 0, data);

const TableFooter = (props) => {
  const { t, data } = props;
  
  return (
    <Table.Footer>
      <Table.Row>
        <Table.HeaderCell colSpan='3'>
          <strong>{t('private:po.teams.currencyEUR')}</strong>
        </Table.HeaderCell>
        <Table.HeaderCell colSpan='2'/>
        <Table.HeaderCell>
          <strong>{sum(data, 'orig_price')}</strong>
        </Table.HeaderCell>
        <Table.HeaderCell/>
        <Table.HeaderCell>
          <strong>{sum(data, 'sale_price')}</strong>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <strong>{sum(data, 'tax')}</strong>
        </Table.HeaderCell>
        <Table.HeaderCell>
          <strong>{sum(data, 'total')}</strong>
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  );
};

export default withNamespaces(['private'])(TableFooter);



// WEBPACK FOOTER //
// ./src/private/common/components/TransactionTable/Footer.js